export default __webpack_public_path__ + "static/media/Sibiraj Nagaimaaligai.bb7ebd2e.png";